import {
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Stack,
  Typography,

} from '@datanomik/commons-ui';
import {
  CheckOutlined,
} from '@mui/icons-material';

import { useTranslation } from 'react-i18next';

type SupportPanelSuggestionsProps = {
  onClose: () => void;
};

export function SupportPanelSuggestionSent({ onClose }: SupportPanelSuggestionsProps) {
  const { t } = useTranslation();

  return (
    <Stack height="100%">
      <DrawerHeader
        text={t('Suggestions & Improvements')}
      />
      <DrawerBody>
        <Stack p="24px" alignItems="center">
          <CheckOutlined color="success" fontSize="large" />
          <Typography variant="h6" textAlign="center" mt={2}>
            {t('Thank you for your suggestion!')}
          </Typography>
          <Typography variant="body1" textAlign="center" mt={1}>
            {t('Your feedback helps us improve our service.')}
          </Typography>

        </Stack>
      </DrawerBody>
      <DrawerFooter>
        <Button
          onClick={onClose}
          sx={{ mt: 4 }}
          fullWidth
        >
          {t('Close')}
        </Button>
      </DrawerFooter>
    </Stack>
  );
}
